// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 20 20%27%3e%3cpath stroke=%27%236b7280%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%271.5%27 d=%27m6 8 4 4 4-4%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.add-edit-court-details-container {
  min-height: calc(100vh - 118px);
  background: #f9fafb;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
@media (max-width: 768px) {
  .add-edit-court-details-container {
    padding: 1rem;
  }
}
.add-edit-court-details-container .add-edit-court-details-wrapper {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 0.375rem;
  padding: 1.5rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  animation: court-details-fade-in 0.3s ease-out;
  width: 70%;
}
@media (max-width: 768px) {
  .add-edit-court-details-container .add-edit-court-details-wrapper {
    padding: 1rem;
    width: 100%;
  }
}
.add-edit-court-details-container .add-edit-court-details-header {
  text-align: center;
  margin-bottom: 0.5rem;
}
.add-edit-court-details-container .add-edit-court-details-header .add-edit-court-details-title {
  font-size: 1.6rem;
  font-weight: 500;
  color: #374151;
  margin: 0 0 0.5rem 0;
}
@media (max-width: 768px) {
  .add-edit-court-details-container .add-edit-court-details-header .add-edit-court-details-title {
    font-size: 1.25rem;
  }
}
.add-edit-court-details-container .add-edit-court-details-header .add-edit-court-details-subtitle {
  font-size: 0.875rem;
  color: #6b7280;
  margin: 0;
}
.add-edit-court-details-container .add-edit-court-details-divider {
  border: none;
  border-top: 1px solid #e5e7eb;
  margin: 1.5rem 0;
}
.add-edit-court-details-container .form-content {
  padding: 0;
  background: transparent;
  border: none;
  box-shadow: none;
  animation: none;
  width: 100%;
}
@media (max-width: 768px) {
  .add-edit-court-details-container .form-content {
    padding: 0;
    width: 100%;
  }
}
.add-edit-court-details-container .form-content .form-section:last-of-type {
  border-bottom: none;
  margin-bottom: 0;
  padding-bottom: 0;
}
.add-edit-court-details-container .form-content .form-section h3 {
  font-size: 1.125rem;
  font-weight: 500;
  color: #374151;
  margin: 0 0 1rem 0;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #e5e7eb;
}
.add-edit-court-details-container .form-content .form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  margin-bottom: 0.5rem;
}
@media (max-width: 768px) {
  .add-edit-court-details-container .form-content .form-grid {
    grid-template-columns: 1fr;
    gap: 0.5rem;
  }
}
.add-edit-court-details-container .form-content .form-grid .court-det-form-group {
  display: flex;
  flex-direction: column;
}
.add-edit-court-details-container .form-content .form-grid .court-det-form-group.full-width {
  grid-column: 1/-1;
}
.add-edit-court-details-container .form-content .form-grid .court-det-form-group label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  font-size: 0.875rem;
  color: #374151;
}
.add-edit-court-details-container .form-content .form-grid .court-det-form-group label .required {
  color: #ef4444;
  margin-left: 0.25rem;
  font-size: 0.875rem;
}
.add-edit-court-details-container .form-content .form-grid .court-det-form-group input,
.add-edit-court-details-container .form-content .form-grid .court-det-form-group select,
.add-edit-court-details-container .form-content .form-grid .court-det-form-group textarea {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #d1d5db;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  font-family: inherit;
  color: #374151;
  background: #ffffff;
  box-sizing: border-box;
  min-height: 2.5rem;
}
.add-edit-court-details-container .form-content .form-grid .court-det-form-group input:focus,
.add-edit-court-details-container .form-content .form-grid .court-det-form-group select:focus,
.add-edit-court-details-container .form-content .form-grid .court-det-form-group textarea:focus {
  outline: none;
  border-color: var(--primary-color, #3b82f6);
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.add-edit-court-details-container .form-content .form-grid .court-det-form-group input:hover:not(:focus),
.add-edit-court-details-container .form-content .form-grid .court-det-form-group select:hover:not(:focus),
.add-edit-court-details-container .form-content .form-grid .court-det-form-group textarea:hover:not(:focus) {
  border-color: #9ca3af;
}
.add-edit-court-details-container .form-content .form-grid .court-det-form-group input::placeholder,
.add-edit-court-details-container .form-content .form-grid .court-det-form-group select::placeholder,
.add-edit-court-details-container .form-content .form-grid .court-det-form-group textarea::placeholder {
  color: #9ca3af;
}
.add-edit-court-details-container .form-content .form-grid .court-det-form-group input:disabled,
.add-edit-court-details-container .form-content .form-grid .court-det-form-group select:disabled,
.add-edit-court-details-container .form-content .form-grid .court-det-form-group textarea:disabled {
  background-color: #f9fafb;
  color: #6b7280;
  cursor: not-allowed;
}
.add-edit-court-details-container .form-content .form-grid .court-det-form-group select {
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: right 0.5rem center;
  background-repeat: no-repeat;
  background-size: 1.5rem 1.5rem;
  padding-right: 2.5rem;
  cursor: pointer;
}
.add-edit-court-details-container .form-content .form-grid .court-det-form-group select:disabled {
  cursor: not-allowed;
}
.add-edit-court-details-container .form-content .form-grid .court-det-form-group select option {
  padding: 0.5rem;
  background: #ffffff;
  color: #374151;
}
.add-edit-court-details-container .form-content .form-grid .court-det-form-group .input-with-button {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}
.add-edit-court-details-container .form-content .form-grid .court-det-form-group .input-with-button .text-input {
  flex: 1 1;
}
.add-edit-court-details-container .form-content .form-grid .court-det-form-group .input-with-button .remove-btn {
  width: 2.5rem;
  height: 2.5rem;
  background-color: #dc2626;
  color: white;
  border: none;
  border-radius: 0.25rem;
  cursor: pointer;
  font-size: 1.125rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease;
  min-width: 2.5rem;
}
.add-edit-court-details-container .form-content .form-grid .court-det-form-group .input-with-button .remove-btn:hover {
  background-color: #b91c1c;
}
.add-edit-court-details-container .form-content .form-grid .court-det-form-group .input-with-button .remove-btn:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.3);
}
.add-edit-court-details-container .form-content .form-grid .court-det-form-group .high-court-inputs {
  display: grid;
  grid-template-columns: 1fr 1fr auto;
  gap: 0.5rem;
  align-items: center;
}
@media (max-width: 768px) {
  .add-edit-court-details-container .form-content .form-grid .court-det-form-group .high-court-inputs {
    grid-template-columns: 1fr;
    gap: 0.5rem;
  }
}
.add-edit-court-details-container .form-content .form-grid .court-det-form-group .high-court-inputs .dropdown {
  width: 100%;
}
.add-edit-court-details-container .form-content .form-grid .court-det-form-group .high-court-inputs .remove-btn {
  width: 2.5rem;
  height: 2.5rem;
  background-color: #dc2626;
  color: white;
  border: none;
  border-radius: 0.25rem;
  cursor: pointer;
  font-size: 1.125rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease;
  min-width: 2.5rem;
}
.add-edit-court-details-container .form-content .form-grid .court-det-form-group .high-court-inputs .remove-btn:hover {
  background-color: #b91c1c;
}
.add-edit-court-details-container .form-content .form-grid .court-det-form-group .high-court-inputs .remove-btn:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.3);
}
@media (max-width: 768px) {
  .add-edit-court-details-container .form-content .form-grid .court-det-form-group .high-court-inputs .remove-btn {
    justify-self: center;
  }
}
.add-edit-court-details-container .form-content .form-grid .court-det-form-group .district-court-inputs {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr auto;
  gap: 0.5rem;
  align-items: center;
}
@media (max-width: 768px) {
  .add-edit-court-details-container .form-content .form-grid .court-det-form-group .district-court-inputs {
    grid-template-columns: 1fr;
    gap: 0.5rem;
  }
}
.add-edit-court-details-container .form-content .form-grid .court-det-form-group .district-court-inputs .text-input {
  width: 100%;
}
.add-edit-court-details-container .form-content .form-grid .court-det-form-group .district-court-inputs .remove-btn {
  width: 2.5rem;
  height: 2.5rem;
  background-color: #dc2626;
  color: white;
  border: none;
  border-radius: 0.25rem;
  cursor: pointer;
  font-size: 1.125rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease;
  min-width: 2.5rem;
}
.add-edit-court-details-container .form-content .form-grid .court-det-form-group .district-court-inputs .remove-btn:hover {
  background-color: #b91c1c;
}
.add-edit-court-details-container .form-content .form-grid .court-det-form-group .district-court-inputs .remove-btn:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.3);
}
@media (max-width: 768px) {
  .add-edit-court-details-container .form-content .form-grid .court-det-form-group .district-court-inputs .remove-btn {
    justify-self: center;
  }
}
.add-edit-court-details-container .form-content .add-btn {
  padding: 8px 18px;
  background-color: #16a34a;
  color: white;
  border: none;
  border-radius: 0.375rem;
  font-weight: 500;
  font-size: 0.875rem;
  cursor: pointer;
  transition: background-color 0.2s ease;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 1.5rem;
}
.add-edit-court-details-container .form-content .add-btn:hover {
  background-color: #15803d;
}
.add-edit-court-details-container .form-content .add-btn:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(34, 197, 94, 0.3);
}
.add-edit-court-details-container .form-content .add-btn:active {
  transform: translateY(1px);
}
.add-edit-court-details-container .form-content .form-actions {
  display: flex;
  justify-content: end;
  gap: 1rem;
  padding-top: 1rem;
  border-top: 1px solid #e5e7eb;
}
@media (max-width: 768px) {
  .add-edit-court-details-container .form-content .form-actions {
    flex-direction: column;
  }
}
.add-edit-court-details-container .form-content .form-actions .btn-cancel,
.add-edit-court-details-container .form-content .form-actions .btn-submit {
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 0.375rem;
  font-weight: 500;
  font-size: 0.875rem;
  cursor: pointer;
  min-width: 120px;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}
@media (max-width: 768px) {
  .add-edit-court-details-container .form-content .form-actions .btn-cancel,
  .add-edit-court-details-container .form-content .form-actions .btn-submit {
    width: 100%;
  }
}
.add-edit-court-details-container .form-content .form-actions .btn-cancel:disabled,
.add-edit-court-details-container .form-content .form-actions .btn-submit:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}
.add-edit-court-details-container .form-content .form-actions .btn-cancel:hover {
  background-color: #f8f9fa;
}
.add-edit-court-details-container .form-content .form-actions .btn-cancel:focus {
  outline: none;
}
.add-edit-court-details-container .form-content .form-actions .btn-cancel:disabled {
  background-color: #d1d5db;
  color: #9ca3af;
}
.add-edit-court-details-container .form-content .form-actions .btn-submit {
  background-color: var(--primary-color);
  color: white;
}
.add-edit-court-details-container .form-content .form-actions .btn-submit:focus {
  outline: none;
}
.add-edit-court-details-container .form-content .form-actions .btn-submit:disabled {
  background-color: #d1d5db;
  color: #9ca3af;
}

@keyframes court-details-fade-in {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@media (max-width: 768px) {
  .add-edit-court-details-container .add-edit-court-details-wrapper {
    width: 100%;
  }
}
@media (max-width: 480px) {
  .add-edit-court-details-container {
    padding: 0.5rem;
  }
  .add-edit-court-details-container .add-edit-court-details-wrapper {
    padding: 0.75rem;
  }
  .add-edit-court-details-container .add-edit-court-details-header .add-edit-court-details-title {
    font-size: 1.125rem;
  }
  .add-edit-court-details-container .add-edit-court-details-header .add-edit-court-details-subtitle {
    font-size: 0.8125rem;
  }
  .add-edit-court-details-container .form-content .form-grid {
    gap: 0.5rem;
  }
  .add-edit-court-details-container .form-content .form-grid .court-det-form-group label {
    font-size: 0.8125rem;
  }
  .add-edit-court-details-container .form-content .form-grid .court-det-form-group input,
  .add-edit-court-details-container .form-content .form-grid .court-det-form-group select,
  .add-edit-court-details-container .form-content .form-grid .court-det-form-group textarea {
    padding: 0.375rem;
    font-size: 0.8125rem;
  }
  .add-edit-court-details-container .form-content .form-actions .btn-cancel,
  .add-edit-court-details-container .form-content .form-actions .btn-submit {
    padding: 0.5rem 1rem;
    font-size: 0.8125rem;
  }
}
@media print {
  .add-edit-court-details-container {
    background: white;
    padding: 0;
  }
  .add-edit-court-details-container .add-edit-court-details-wrapper {
    box-shadow: none;
    border: 1px solid #000;
  }
  .add-edit-court-details-container .form-actions {
    display: none;
  }
}
.add-edit-court-details-container input:focus-visible,
.add-edit-court-details-container select:focus-visible,
.add-edit-court-details-container textarea:focus-visible,
.add-edit-court-details-container button:focus-visible {
  outline: 2px solid var(--primary-color, #3b82f6);
  outline-offset: 2px;
}`, "",{"version":3,"sources":["webpack://./src/forms/AddEditCourtDetailsForm/AddEditCourtDetailsForm.scss"],"names":[],"mappings":"AACA;EACE,+BAAA;EACA,mBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AAAF;AAEE;EATF;IAUI,aAAA;EACF;AACF;AAEE;EACE,mBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,wCAAA;EACA,8CAAA;EACA,UAAA;AAAJ;AAEI;EATF;IAUI,aAAA;IACA,WAAA;EACJ;AACF;AAGE;EACE,kBAAA;EACA,qBAAA;AADJ;AAGI;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,oBAAA;AADN;AAGM;EANF;IAOI,kBAAA;EAAN;AACF;AAGI;EACE,mBAAA;EACA,cAAA;EACA,SAAA;AADN;AAME;EACE,YAAA;EACA,6BAAA;EACA,gBAAA;AAJJ;AAQE;EACE,UAAA;EACA,uBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;AANJ;AAQI;EARF;IASI,UAAA;IACA,WAAA;EALJ;AACF;AAUM;EACE,mBAAA;EACA,gBAAA;EACA,iBAAA;AARR;AAWM;EACE,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,gCAAA;AATR;AAcI;EACE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,qBAAA;AAZN;AAcM;EANF;IAOI,0BAAA;IACA,WAAA;EAXN;AACF;AAaM;EACE,aAAA;EACA,sBAAA;AAXR;AAaQ;EACE,iBAAA;AAXV;AAcQ;EACE,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AAZV;AAcU;EACE,cAAA;EACA,oBAAA;EACA,mBAAA;AAZZ;AAiBQ;;;EAGE,WAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,oBAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;AAfV;AAiBU;;;EACE,aAAA;EACA,2CAAA;EACA,6CAAA;AAbZ;AAgBU;;;EACE,qBAAA;AAZZ;AAeU;;;EACE,cAAA;AAXZ;AAcU;;;EACE,yBAAA;EACA,cAAA;EACA,mBAAA;AAVZ;AAcQ;EACE,gBAAA;EACA,yDAAA;EACA,wCAAA;EACA,4BAAA;EACA,8BAAA;EACA,qBAAA;EACA,eAAA;AAZV;AAcU;EACE,mBAAA;AAZZ;AAeU;EACE,eAAA;EACA,mBAAA;EACA,cAAA;AAbZ;AAkBQ;EACE,aAAA;EACA,WAAA;EACA,mBAAA;AAhBV;AAkBU;EACE,SAAA;AAhBZ;AAmBU;EACE,aAAA;EACA,cAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;EACA,eAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sCAAA;EACA,iBAAA;AAjBZ;AAmBY;EACE,yBAAA;AAjBd;AAoBY;EACE,aAAA;EACA,4CAAA;AAlBd;AAwBQ;EACE,aAAA;EACA,mCAAA;EACA,WAAA;EACA,mBAAA;AAtBV;AAwBU;EANF;IAOI,0BAAA;IACA,WAAA;EArBV;AACF;AAuBU;EACE,WAAA;AArBZ;AAwBU;EACE,aAAA;EACA,cAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;EACA,eAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sCAAA;EACA,iBAAA;AAtBZ;AAwBY;EACE,yBAAA;AAtBd;AAyBY;EACE,aAAA;EACA,4CAAA;AAvBd;AA0BY;EAxBF;IAyBI,oBAAA;EAvBZ;AACF;AA4BQ;EACE,aAAA;EACA,uCAAA;EACA,WAAA;EACA,mBAAA;AA1BV;AA4BU;EANF;IAOI,0BAAA;IACA,WAAA;EAzBV;AACF;AA2BU;EACE,WAAA;AAzBZ;AA4BU;EACE,aAAA;EACA,cAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;EACA,eAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sCAAA;EACA,iBAAA;AA1BZ;AA4BY;EACE,yBAAA;AA1Bd;AA6BY;EACE,aAAA;EACA,4CAAA;AA3Bd;AA8BY;EAxBF;IAyBI,oBAAA;EA3BZ;AACF;AAkCI;EACE,iBAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,sCAAA;EACA,oBAAA;EACA,mBAAA;EACA,WAAA;EACA,qBAAA;AAhCN;AAkCM;EACE,yBAAA;AAhCR;AAmCM;EACE,aAAA;EACA,4CAAA;AAjCR;AAoCM;EACE,0BAAA;AAlCR;AAuCI;EACE,aAAA;EACA,oBAAA;EACA,SAAA;EACA,iBAAA;EACA,6BAAA;AArCN;AAuCM;EAPF;IAQI,sBAAA;EApCN;AACF;AAsCM;;EAEE,uBAAA;EACA,YAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AApCR;AAsCQ;EAfF;;IAgBI,WAAA;EAlCR;AACF;AAoCQ;;EACE,mBAAA;EACA,YAAA;AAjCV;AA4CQ;EACI,yBAAA;AA1CZ;AA6CQ;EACE,aAAA;AA3CV;AA+CQ;EACE,yBAAA;EACA,cAAA;AA7CV;AAiDM;EACE,sCAAA;EACA,YAAA;AA/CR;AAqDQ;EACE,aAAA;AAnDV;AAuDQ;EACE,yBAAA;EACA,cAAA;AArDV;;AA6DA;EACE;IACE,UAAA;IACA,2BAAA;EA1DF;EA6DA;IACE,UAAA;IACA,wBAAA;EA3DF;AACF;AA+DA;EAEI;IACE,WAAA;EA9DJ;AACF;AAkEA;EACE;IACE,eAAA;EAhEF;EAkEE;IACE,gBAAA;EAhEJ;EAoEI;IACE,mBAAA;EAlEN;EAqEI;IACE,oBAAA;EAnEN;EAwEI;IACE,WAAA;EAtEN;EAyEQ;IACE,oBAAA;EAvEV;EA0EQ;;;IAGE,iBAAA;IACA,oBAAA;EAxEV;EA8EM;;IAEE,oBAAA;IACA,oBAAA;EA5ER;AACF;AAmFA;EACE;IACE,iBAAA;IACA,UAAA;EAjFF;EAmFE;IACE,gBAAA;IACA,sBAAA;EAjFJ;EAoFE;IACE,aAAA;EAlFJ;AACF;AAwFE;;;;EAIE,gDAAA;EACA,mBAAA;AAtFJ","sourcesContent":["// Main Container\r\n.add-edit-court-details-container {\r\n  min-height: calc(100vh - 118px);\r\n  background: #f9fafb;\r\n  padding: 2rem;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n\r\n  @media (max-width: 768px) {\r\n    padding: 1rem;\r\n  }\r\n\r\n  // Form Wrapper - New wrapper structure\r\n  .add-edit-court-details-wrapper {\r\n    background: #ffffff;\r\n    border: 1px solid #e5e7eb;\r\n    border-radius: 0.375rem;\r\n    padding: 1.5rem;\r\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\r\n    animation: court-details-fade-in 0.3s ease-out;\r\n    width: 70%;\r\n\r\n    @media (max-width: 768px) {\r\n      padding: 1rem;\r\n      width: 100%;\r\n    }\r\n  }\r\n\r\n  // Header styling (moved inside wrapper)\r\n  .add-edit-court-details-header {\r\n    text-align: center;\r\n    margin-bottom: 0.5rem;\r\n\r\n    .add-edit-court-details-title {\r\n      font-size: 1.6rem;\r\n      font-weight: 500;\r\n      color: #374151;\r\n      margin: 0 0 0.5rem 0;\r\n\r\n      @media (max-width: 768px) {\r\n        font-size: 1.25rem;\r\n      }\r\n    }\r\n\r\n    .add-edit-court-details-subtitle {\r\n      font-size: 0.875rem;\r\n      color: #6b7280;\r\n      margin: 0;\r\n    }\r\n  }\r\n\r\n  // Divider styling\r\n  .add-edit-court-details-divider {\r\n    border: none;\r\n    border-top: 1px solid #e5e7eb;\r\n    margin: 1.5rem 0;\r\n  }\r\n\r\n  // Form styling - Updated to work with wrapper\r\n  .form-content {\r\n    padding: 0; // Remove padding since it's now in wrapper\r\n    background: transparent;\r\n    border: none;\r\n    box-shadow: none;\r\n    animation: none;\r\n    width: 100%;\r\n\r\n    @media (max-width: 768px) {\r\n      padding: 0;\r\n      width: 100%;\r\n    }\r\n\r\n    // Form sections\r\n    .form-section {\r\n\r\n      &:last-of-type {\r\n        border-bottom: none;\r\n        margin-bottom: 0;\r\n        padding-bottom: 0;\r\n      }\r\n\r\n      h3 {\r\n        font-size: 1.125rem;\r\n        font-weight: 500;\r\n        color: #374151;\r\n        margin: 0 0 1rem 0;\r\n        padding-bottom: 0.5rem;\r\n        border-bottom: 1px solid #e5e7eb;\r\n      }\r\n    }\r\n\r\n    // Form grid for court details\r\n    .form-grid {\r\n      display: grid;\r\n      grid-template-columns: 1fr 1fr;\r\n      gap: 1rem;\r\n      margin-bottom: 0.5rem;\r\n\r\n      @media (max-width: 768px) {\r\n        grid-template-columns: 1fr;\r\n        gap: 0.5rem;\r\n      }\r\n\r\n      .court-det-form-group {\r\n        display: flex;\r\n        flex-direction: column;\r\n\r\n        &.full-width {\r\n          grid-column: 1 / -1;\r\n        }\r\n\r\n        label {\r\n          display: block;\r\n          margin-bottom: 0.5rem;\r\n          font-weight: 500;\r\n          font-size: 0.875rem;\r\n          color: #374151;\r\n\r\n          .required {\r\n            color: #ef4444;\r\n            margin-left: 0.25rem;\r\n            font-size: 0.875rem;\r\n          }\r\n        }\r\n\r\n        // Input styling to match SACompanyForm\r\n        input,\r\n        select,\r\n        textarea {\r\n          width: 100%;\r\n          padding: 0.5rem;\r\n          border: 1px solid #d1d5db;\r\n          border-radius: 0.25rem;\r\n          font-size: 0.875rem;\r\n          font-family: inherit;\r\n          color: #374151;\r\n          background: #ffffff;\r\n          box-sizing: border-box;\r\n          min-height: 2.5rem;\r\n\r\n          &:focus {\r\n            outline: none;\r\n            border-color: var(--primary-color, #3b82f6);\r\n            box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\r\n          }\r\n\r\n          &:hover:not(:focus) {\r\n            border-color: #9ca3af;\r\n          }\r\n\r\n          &::placeholder {\r\n            color: #9ca3af;\r\n          }\r\n\r\n          &:disabled {\r\n            background-color: #f9fafb;\r\n            color: #6b7280;\r\n            cursor: not-allowed;\r\n          }\r\n        }\r\n\r\n        select {\r\n          appearance: none;\r\n          background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3e%3c/svg%3e\");\r\n          background-position: right 0.5rem center;\r\n          background-repeat: no-repeat;\r\n          background-size: 1.5rem 1.5rem;\r\n          padding-right: 2.5rem;\r\n          cursor: pointer;\r\n\r\n          &:disabled {\r\n            cursor: not-allowed;\r\n          }\r\n\r\n          option {\r\n            padding: 0.5rem;\r\n            background: #ffffff;\r\n            color: #374151;\r\n          }\r\n        }\r\n\r\n        // Special styling for input groups with buttons\r\n        .input-with-button {\r\n          display: flex;\r\n          gap: 0.5rem;\r\n          align-items: center;\r\n\r\n          .text-input {\r\n            flex: 1;\r\n          }\r\n\r\n          .remove-btn {\r\n            width: 2.5rem;\r\n            height: 2.5rem;\r\n            background-color: #dc2626;\r\n            color: white;\r\n            border: none;\r\n            border-radius: 0.25rem;\r\n            cursor: pointer;\r\n            font-size: 1.125rem;\r\n            display: flex;\r\n            align-items: center;\r\n            justify-content: center;\r\n            transition: background-color 0.2s ease;\r\n            min-width: 2.5rem;\r\n\r\n            &:hover {\r\n              background-color: #b91c1c;\r\n            }\r\n\r\n            &:focus {\r\n              outline: none;\r\n              box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.3);\r\n            }\r\n          }\r\n        }\r\n\r\n        // High Court inputs styling\r\n        .high-court-inputs {\r\n          display: grid;\r\n          grid-template-columns: 1fr 1fr auto;\r\n          gap: 0.5rem;\r\n          align-items: center;\r\n\r\n          @media (max-width: 768px) {\r\n            grid-template-columns: 1fr;\r\n            gap: 0.5rem;\r\n          }\r\n\r\n          .dropdown {\r\n            width: 100%;\r\n          }\r\n\r\n          .remove-btn {\r\n            width: 2.5rem;\r\n            height: 2.5rem;\r\n            background-color: #dc2626;\r\n            color: white;\r\n            border: none;\r\n            border-radius: 0.25rem;\r\n            cursor: pointer;\r\n            font-size: 1.125rem;\r\n            display: flex;\r\n            align-items: center;\r\n            justify-content: center;\r\n            transition: background-color 0.2s ease;\r\n            min-width: 2.5rem;\r\n\r\n            &:hover {\r\n              background-color: #b91c1c;\r\n            }\r\n\r\n            &:focus {\r\n              outline: none;\r\n              box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.3);\r\n            }\r\n\r\n            @media (max-width: 768px) {\r\n              justify-self: center;\r\n            }\r\n          }\r\n        }\r\n\r\n        // District Court inputs styling\r\n        .district-court-inputs {\r\n          display: grid;\r\n          grid-template-columns: 1fr 1fr 1fr auto;\r\n          gap: 0.5rem;\r\n          align-items: center;\r\n\r\n          @media (max-width: 768px) {\r\n            grid-template-columns: 1fr;\r\n            gap: 0.5rem;\r\n          }\r\n\r\n          .text-input {\r\n            width: 100%;\r\n          }\r\n\r\n          .remove-btn {\r\n            width: 2.5rem;\r\n            height: 2.5rem;\r\n            background-color: #dc2626;\r\n            color: white;\r\n            border: none;\r\n            border-radius: 0.25rem;\r\n            cursor: pointer;\r\n            font-size: 1.125rem;\r\n            display: flex;\r\n            align-items: center;\r\n            justify-content: center;\r\n            transition: background-color 0.2s ease;\r\n            min-width: 2.5rem;\r\n\r\n            &:hover {\r\n              background-color: #b91c1c;\r\n            }\r\n\r\n            &:focus {\r\n              outline: none;\r\n              box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.3);\r\n            }\r\n\r\n            @media (max-width: 768px) {\r\n              justify-self: center;\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n\r\n    // Add button styling\r\n    .add-btn {\r\n      padding:8px 18px;\r\n      background-color: #16a34a;\r\n      color: white;\r\n      border: none;\r\n      border-radius: 0.375rem;\r\n      font-weight: 500;\r\n      font-size: 0.875rem;\r\n      cursor: pointer;\r\n      transition: background-color 0.2s ease;\r\n      display: inline-flex;\r\n      align-items: center;\r\n      gap: 0.5rem;\r\n      margin-bottom: 1.5rem;\r\n\r\n      &:hover {\r\n        background-color: #15803d;\r\n      }\r\n\r\n      &:focus {\r\n        outline: none;\r\n        box-shadow: 0 0 0 3px rgba(34, 197, 94, 0.3);\r\n      }\r\n\r\n      &:active {\r\n        transform: translateY(1px);\r\n      }\r\n    }\r\n\r\n    // Form actions\r\n    .form-actions {\r\n      display: flex;\r\n      justify-content: end;\r\n      gap: 1rem;\r\n      padding-top: 1rem;\r\n      border-top: 1px solid #e5e7eb;\r\n\r\n      @media (max-width: 768px) {\r\n        flex-direction: column;\r\n      }\r\n\r\n      .btn-cancel,\r\n      .btn-submit {\r\n        padding: 0.75rem 1.5rem;\r\n        border: none;\r\n        border-radius: 0.375rem;\r\n        font-weight: 500;\r\n        font-size: 0.875rem;\r\n        cursor: pointer;\r\n        min-width: 120px;\r\n        transition: all 0.2s ease;\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n        gap: 0.5rem;\r\n\r\n        @media (max-width: 768px) {\r\n          width: 100%;\r\n        }\r\n\r\n        &:disabled {\r\n          cursor: not-allowed;\r\n          opacity: 0.6;\r\n        }\r\n      }\r\n\r\n      .btn-cancel {\r\n        // background: #dc3545;\r\n        // color: white;\r\n\r\n        // &:hover:not(:disabled) {\r\n        //   background-color: #b91c1c;\r\n        // }\r\n        &:hover{\r\n            background-color: #f8f9fa;\r\n        }\r\n\r\n        &:focus {\r\n          outline: none;\r\n          //box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.3);\r\n        }\r\n\r\n        &:disabled {\r\n          background-color: #d1d5db;\r\n          color: #9ca3af;\r\n        }\r\n      }\r\n\r\n      .btn-submit {\r\n        background-color: var(--primary-color);\r\n        color: white;\r\n\r\n        // &:hover:not(:disabled) {\r\n        //   background-color: #15803d;\r\n        // }\r\n\r\n        &:focus {\r\n          outline: none;\r\n          //box-shadow: 0 0 0 3px rgba(34, 197, 94, 0.3);\r\n        }\r\n\r\n        &:disabled {\r\n          background-color: #d1d5db;\r\n          color: #9ca3af;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n// Animations\r\n@keyframes court-details-fade-in {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(10px);\r\n  }\r\n\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n// Responsive design improvements\r\n@media (max-width: 768px) {\r\n  .add-edit-court-details-container {\r\n    .add-edit-court-details-wrapper {\r\n      width: 100%;\r\n    }\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .add-edit-court-details-container {\r\n    padding: 0.5rem;\r\n\r\n    .add-edit-court-details-wrapper {\r\n      padding: 0.75rem;\r\n    }\r\n\r\n    .add-edit-court-details-header {\r\n      .add-edit-court-details-title {\r\n        font-size: 1.125rem;\r\n      }\r\n\r\n      .add-edit-court-details-subtitle {\r\n        font-size: 0.8125rem;\r\n      }\r\n    }\r\n\r\n    .form-content {\r\n      .form-grid {\r\n        gap: 0.5rem;\r\n\r\n        .court-det-form-group {\r\n          label {\r\n            font-size: 0.8125rem;\r\n          }\r\n\r\n          input,\r\n          select,\r\n          textarea {\r\n            padding: 0.375rem;\r\n            font-size: 0.8125rem;\r\n          }\r\n        }\r\n      }\r\n\r\n      .form-actions {\r\n        .btn-cancel,\r\n        .btn-submit {\r\n          padding: 0.5rem 1rem;\r\n          font-size: 0.8125rem;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n// Print styles\r\n@media print {\r\n  .add-edit-court-details-container {\r\n    background: white;\r\n    padding: 0;\r\n\r\n    .add-edit-court-details-wrapper {\r\n      box-shadow: none;\r\n      border: 1px solid #000;\r\n    }\r\n\r\n    .form-actions {\r\n      display: none;\r\n    }\r\n  }\r\n}\r\n\r\n// Focus visible improvements for accessibility\r\n.add-edit-court-details-container {\r\n  input:focus-visible,\r\n  select:focus-visible,\r\n  textarea:focus-visible,\r\n  button:focus-visible {\r\n    outline: 2px solid var(--primary-color, #3b82f6);\r\n    outline-offset: 2px;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
